import React from 'react';
import {Row, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import RegisteredLocations from '../RegisteredLocations';
import DivergentOwnerStep from './DivergentOwnerStep';
import DivergentBillingStep from './DivergentBillingStep';
import ConsumptionPoint from '../FormGroups/ConsumptionPoint';
import RegistrationLocation from '../FormGroups/RegistrationLocation';

const initialState = {
  accountnumber: '',
  meternumber: '',
  meterreading: '',
  metertype: '',
  refnumber: '',
  street: '',
  housenumber: '',
  housenumberextension: '',
  postcode: '',
  city: '',
  additionalMeter: 'gas',
  additionalMeternumber: '',
  additionalMeterreading: '',
  divergentInvoice: false,
  showInvoice: false,
  administrationIsOwner: true,
  addedGas: false,
  DeviantOwner: {
    salutation: '02',
    street: ''
  },
  InvoiceReceiver: {
    salutation: '02',
    street: ''
  }
};
const initialValidation = {
  adressValidation: false,
  locationValidation: false,
  divOwnerVal: true,
  divLocVal: true,
}

class RegisterLocationStep extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {
      ...initialState
    };
    this.duplicate = false;
    this.submitted = false;
    this.ValidForm = {
      ...initialValidation
    };
    this.validOwner = {
      adressValidation: true,
      nameValidation: true
    }
    this.validDivLoc = {
      adressValidation: true,
      nameValidation: true
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.isValidated = this.isValidated.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.isDivOwnerValid = this.isDivOwnerValid.bind(this);
    this.isDivLocValid = this.isDivLocValid.bind(this);
    this.handleInvoiceInfoChange = this.handleInvoiceInfoChange.bind(this);
    this.handleLocationRemoval = this.handleLocationRemoval.bind(this);
    this.handleDivergentOwner = this.handleDivergentOwner.bind(this);
    this.handleDivergentChange = this.handleDivergentChange.bind(this);
    this.handleChangeChecked = this.handleChangeChecked.bind(this);
  }

  componentDidMount(){
    this.setState({
      metertype: this.props.type
    });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  handleDivergentChange(property, isChanged){
    this.setState({
      [property]: isChanged
    });
    // toggle if validation is necessary here
    if(property === 'administrationIsOwner') {
      this.ValidForm.divOwnerVal = isChanged;
    } else {
      this.ValidForm.divLocVal = !isChanged;
    }
  }

  handleInvoiceInfoChange(event) {
    const location = {...this.state};
    location.InvoiceReceiver[event.target.name] = event.target.value;
    this.setState(location);
  }

  handleDivergentOwner(event) {
    const location = {...this.state};
    location.DeviantOwner[event.target.name] = event.target.value;
    this.setState(location);
  }

  handleLocationRemoval(event){
    const reg = this.props.LocationRegistrations.filter(reg => reg.meternumber === event.currentTarget.id)[0]

    const indexOfElement = this.props.LocationRegistrations.indexOf(reg);
    this.props.removeRegistration(indexOfElement);
  }

  async handleSubmit(event){
    event.preventDefault();
    this.submitted = true;
    this.duplicate = false;
    this.forceUpdate(); // to give the fields a first check with feedback

    if(this.ValidForm.adressValidation && this.ValidForm.locationValidation
        && this.ValidForm.divOwnerVal && this.ValidForm.divLocVal){
      // do submit here
      this.submitted = false;
      const registrations = this.props.LocationRegistrations;
      if (registrations.length > 0) {
        if(this.state.meternumber === registrations[0].meternumber) {
          this.duplicate = true;
          return;
        }
      }
      document.getElementById("addLocationButton").classList.remove("input-needed");
      if (this.state.metertype === "gas") {
        await this.setState({
          city: 'Berlin'});
      }
      const newLocation = this.state;
      this.props.addRegistration(newLocation);
      await this.addGas();
      this.setState({...initialState, DeviantOwner: {...initialState.DeviantOwner}, InvoiceReceiver: {...initialState.InvoiceReceiver}, metertype: this.props.type}, () => {
        this.ValidForm = {
          ...initialValidation
        }
        this.resetCheckbox();
        this.forceUpdate();
      });
    }
  }
  resetCheckbox() {
      this.setState({
        addedGas: false});
    }

  handleChangeChecked() {
    this.setState({
      addedGas: !this.state.addedGas});
  }

 async addGas() {
    if (this.state.addedGas && this.state.metertype === "electricity") {
      this.setState({
        metertype: this.state.additionalMeter,
        meternumber: this.state.additionalMeternumber,
        meterreading:   this.state.additionalMeterreading
      }, () => {
      var newLoc = this.state;
      this.props.handleAdditionalGas();
      this.props.addRegistration(newLoc);
    });
  }
 }

  isValidated() {
    if(this.props.LocationRegistrations.length !== 0) {
      return true;
    }
    document.getElementById("addLocationButton").classList.add("input-needed");
    return false;
  }

  isFormValid(isValid, whereValid) {
    this.ValidForm[whereValid] = isValid;
  }

  isDivOwnerValid(isValid, whereValid) {
    this.validOwner[whereValid] = isValid;
    if(this.validOwner.adressValidation && this.validOwner.nameValidation) {
      this.isFormValid(true, 'divOwnerVal');
    } else {
      this.isFormValid(false, 'divOwnerVal');
    }
  }
  
  isDivLocValid(isValid, whereValid) {
    this.validDivLoc[whereValid] = isValid;
    if(this.validDivLoc.adressValidation && this.validDivLoc.nameValidation) {
      this.isFormValid(true, 'divLocVal')
    } else {
      this.isFormValid(false, 'divLocVal');
    }
  }

  render() {
    let duplicateError;
    if (this.duplicate) {
      duplicateError =
        <h5 style={{ color: 'red', marginTop: '5px' }}>Verbrauchsstelle bereits hinzugefügt! Bitte überprüfen Sie ihre Angaben und fügen die Verbrauchstelle erneut hinzu.</h5>
    }
    return(
    <div>
    <Form onSubmit={this.handleSubmit}>

        <hr></hr>
        <h5>Bitte geben Sie hier die Daten zur Verbrauchsstelle an.</h5>
        <hr></hr>
        <RegistrationLocation changeHandler={this.handleChange}
                    submitted={this.submitted}
                    state={this.state}
                    isValidForm={this.isFormValid}
                    isRegistration={true} />

        <ConsumptionPoint changeHandler={this.handleChange}
                    submitted={this.submitted}
                    state={this.state}
                    isValidForm={this.isFormValid}
                    isRegistration={true}
                    type={this.props.type}
                    handleChangeChecked={this.handleChangeChecked}
                    checked={this.state.addedGas}
                    additionalMeternumber= {this.state.additionalMeternumber}
                    additionalMeterreading= {this.state.additionalMeterreading} />

        <Row>
          <FormGroup tag="fieldset">
            <legend>Abweichender Eigentümer</legend>
            <hr></hr>
            <h5>Wenn Sie nicht der Eigentümer des Mietobjektes sind, übermitteln Sie uns bitte die Daten des Eigentümers, der Vertragspartner des Leerstandsvertrages wird.</h5>
            <hr></hr>
            <FormGroup check>
              <Label check>
                <Input type="radio" defaultChecked={this.state.administrationIsOwner} name="divergent-building-owner" onClick={this.handleDivergentChange.bind(this, 'administrationIsOwner', true)}/>{' '}
                Die Verwaltung ist auch Eigentümer der Wohnung.
              </Label>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input type="radio" defaultChecked={!this.state.administrationIsOwner} name="divergent-building-owner" onClick={this.handleDivergentChange.bind(this, 'administrationIsOwner', false)}/>{' '}
                Die Verwaltung ist nicht Eigentümer der Wohnung. Der Eigentümer hat der Verwaltung jedoch die Vollmacht erteilt, den Leerstand anzumelden.
              </Label>
            </FormGroup>
          </FormGroup>
        </Row>
        { this.state.administrationIsOwner ? null : <DivergentOwnerStep changeHandler={this.handleDivergentOwner}
                                                                        submitted={this.submitted}
                                                                        state={this.state.DeviantOwner}
                                                                        isValidForm={this.isDivOwnerValid} />}

        <Row>
          <FormGroup tag="fieldset">
            <legend>Abweichender Rechnungsempfänger</legend>
            <FormGroup check>
              <Label check>
                <Input type="radio" defaultChecked={!this.state.showInvoice} name="divergent-invoice-address" onClick={this.handleDivergentChange.bind(this, 'divergentInvoice', false)}/>{' '}
                Die Rechnungsadresse ist die Anschrift der Verwaltung.
              </Label>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input type="radio" defaultChecked={this.state.showInvoice} name="divergent-invoice-address" onClick={this.handleDivergentChange.bind(this, 'divergentInvoice', true)}/>{' '}
                Die Rechnungsadresse weicht ab.
              </Label>
            </FormGroup>
          </FormGroup>
        </Row>
        { this.state.divergentInvoice ? <DivergentBillingStep changeHandler={this.handleInvoiceInfoChange}
                                                                        submitted={this.submitted}
                                                                        state={this.state.InvoiceReceiver}
                                                                        isValidForm={this.isDivLocValid} /> : null }

        <hr></hr>
        <h5>Bitte klicken Sie auf "Verbrauchsstelle hinzufügen", um Ihre Angaben zu bestätigen. Um weitere Verbrauchstellen anzumelden, füllen Sie bitte die obigen Eingabefelder erneut aus und klicken wieder auf "Verbrauchsstelle hinzufügen".</h5>
        <hr></hr>
        <Button className="mt-1" id="addLocationButton" type="submit" value="Submit">Verbrauchstelle hinzufügen</Button>
        {duplicateError}
      </Form>
      <RegisteredLocations LocationRegistrations={this.props.LocationRegistrations} HandleRegistrationRemoval={this.handleLocationRemoval.bind(this)} />
      </div>
    );
  }
}

export default RegisterLocationStep;


// WEBPACK FOOTER //
// ./src/components/Steps/RegisterLocationStep.js